import { H6, P, Image } from "@template/components";
import * as S from "./styles.ts";
import { StaticImageData } from "next/image";
import { CountryPrice } from "@/redux/slices/callcosts/type.ts";

export interface IInternationalCostCardProps {
  destination: string;
  destinationFlagUrl: string | StaticImageData;
  priceDetails?: { price: string; copy: string }[];
  showLabels?: boolean;
}

export const InternationalCostCard = ({
  country_name,
  flag_url,
  landline_pence,
  mobile_pence,
  showLabels,
}: CountryPrice & { showLabels?: boolean }) => {
  return (
    <S.IntlCostCardContainer $showLabels={showLabels}>
      <S.Labels $showLabels={showLabels}>
        <S.Destination>
          <P>Destination</P>
        </S.Destination>

        <S.PriceLabel>
          <P>Landline</P>
          <P>/min</P>
        </S.PriceLabel>
        <S.PriceLabel>
          <P>Mobile</P>
          <P>/min</P>
        </S.PriceLabel>
      </S.Labels>

      <S.Row>
        <S.Destination>
          <S.Flag>
            <Image
              src={flag_url}
              alt={`Flag of ${country_name}`}
              width={32}
              height={32}
            />
          </S.Flag>
          <H6>{country_name}</H6>
        </S.Destination>

        <S.Price>
          <P>{landline_pence}P</P>
        </S.Price>
        <S.Price>
          <P>{mobile_pence}P</P>
        </S.Price>
      </S.Row>
    </S.IntlCostCardContainer>
  );
};
